module.exports = __webpack_public_path__ + "img/img-38.28061b26.png";